import React, { useState } from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Badge } from '../components/ui/badge';
import { CheckCircle2 } from 'lucide-react';
import { products } from '../mockData';

const Products = () => {
  const [selectedCategory, setSelectedCategory] = useState('Tümü');

  const categories = ['Tümü', 'Fuji Therma Serisi', 'Koctech Özel Serisi', 'VRF Sistemleri', 'Ticari Klimalar'];

  const filteredProducts = selectedCategory === 'Tümü'
    ? products
    : products.filter(p => p.category === selectedCategory);

  return (
    <div className="min-h-screen pt-32 pb-20 px-4">
      <div className="container mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-5xl font-bold text-gray-900 mb-4">Ürünlerimiz</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Enerji verimliliği yüksek, modern teknolojiye sahip klima sistemleri
          </p>
          <div className="mt-6 inline-block bg-gradient-to-r from-teal-50 to-blue-50 px-6 py-3 rounded-lg border-2 border-teal-500">
            <p className="text-teal-700 font-semibold">
              ⭐ Yeni: <span className="text-teal-900 font-bold">Fuji Therma Serisi</span> - Premium Japon teknolojisi
            </p>
          </div>
        </div>

        {/* Category Filter */}
        <div className="flex flex-wrap justify-center gap-4 mb-12">
          {categories.map((category) => (
            <Button
              key={category}
              onClick={() => setSelectedCategory(category)}
              variant={selectedCategory === category ? 'default' : 'outline'}
              className={`${
                selectedCategory === category
                  ? 'bg-teal-500 hover:bg-teal-600 text-white'
                  : 'border-teal-500 text-teal-600 hover:bg-teal-50'
              } transition-all duration-300`}
            >
              {category}
            </Button>
          ))}
        </div>

        {/* Products Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredProducts.map((product) => (
            <Card key={product.id} className="overflow-hidden border-none shadow-lg hover:shadow-2xl transition-all duration-300 group">
              <div className="relative h-72 overflow-hidden">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <Badge className="absolute top-4 right-4 bg-teal-500 hover:bg-teal-600 text-white">
                  {product.energyClass}
                </Badge>
              </div>
              <CardContent className="p-6">
                <Badge variant="outline" className="mb-3 border-teal-500 text-teal-600">
                  {product.category}
                </Badge>
                <h3 className="text-2xl font-bold text-gray-900 mb-2">{product.name}</h3>
                <p className="text-gray-600 mb-4">{product.description}</p>
                <div className="flex items-center justify-between mb-4">
                  <div>
                    <div className="text-sm text-gray-500">Kapasite</div>
                    <div className="text-2xl font-bold text-teal-600">{product.btu} BTU</div>
                  </div>
                  <div className="text-right">
                    <div className="text-sm text-gray-500">Enerji Sınıfı</div>
                    <div className="text-2xl font-bold text-green-600">{product.energyClass}</div>
                  </div>
                </div>
                <div className="border-t pt-4">
                  <h4 className="font-semibold text-gray-900 mb-3">Özellikler:</h4>
                  <ul className="space-y-2">
                    {product.features.map((feature, index) => (
                      <li key={index} className="flex items-start">
                        <CheckCircle2 className="w-5 h-5 text-teal-500 mr-2 mt-0.5 flex-shrink-0" />
                        <span className="text-sm text-gray-700">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                <Button className="w-full mt-6 bg-teal-500 hover:bg-teal-600 text-white shadow-md hover:shadow-lg transition-all duration-300">
                  Teklif Al
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center bg-gradient-to-br from-teal-50 to-blue-50 rounded-2xl p-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Size Uygun Klima Modelini Bulamadınız mı?
          </h2>
          <p className="text-xl text-gray-600 mb-6">
            AI destekli öneri sistemimiz ile ihtiyacınıza en uygun klima modelini bulun
          </p>
          <Button size="lg" className="bg-teal-500 hover:bg-teal-600 text-white shadow-lg hover:shadow-xl transition-all duration-300">
            Klima Önerisi Al
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Products;